import { NgModule, Optional, SkipSelf } from '@angular/core';

import { provideNgxWebstorage, withLocalStorage } from 'ngx-webstorage';

import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [],
  imports: [SharedModule],
  providers: [provideNgxWebstorage(withLocalStorage())],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}
